import { Box } from "@material-ui/core";
import React, { lazy, Suspense, useEffect } from "react";
import { Route, Switch, useHistory, useLocation } from "react-router-dom";
import ListingLayout from "../../Components/UI/ListingLayout";
import { useSelector } from "react-redux";

const ReviewPackages = lazy(() => import("../Promotion/Packages"));
const History = lazy(() => import("../Location/History"));

const PackageTabs = () => {
  const location = useLocation();
  const history = useHistory();
  const prepath = `/d/review/packages`;
  const { activeLocation } = useSelector(
    (state) => state.SlickCareProfilesReducer,
  );
  const urlWallet = new URLSearchParams(location.search).get("wallet");
  const onOrderHistory = location.pathname.includes("/order-history");
  let storedWallet = null;
  if (onOrderHistory) {
    try {
      storedWallet = sessionStorage.getItem("ai_packages_wallet");
    } catch (e) {
      storedWallet = null;
    }
  }
  const walletParam =
    urlWallet === "care_planning" || urlWallet === "general"
      ? urlWallet
      : storedWallet === "care_planning" || storedWallet === "general"
        ? storedWallet
        : null;
  const isAiWallet =
    walletParam === "care_planning" || walletParam === "general";
  const packagesPath = isAiWallet
    ? `${prepath}?wallet=${walletParam}`
    : `${prepath}`;
  const orderParams = new URLSearchParams();
  if (activeLocation?.id) {
    orderParams.set("location_id", String(activeLocation.id));
  }
  if (isAiWallet) {
    orderParams.set("wallet", walletParam);
  }
  const orderQuery = orderParams.toString();
  const paths = [
    {
      title: "Packages",
      path: packagesPath,
      item_name: "PACKAGES",
      path_to_match: `${prepath}`,
    },
    {
      title: "Order History",
      path: orderQuery
        ? `${prepath}/order-history?${orderQuery}`
        : `${prepath}/order-history`,
      item_name: "ORDERS",
      path_to_match: `${prepath}/order-history`,
    },
  ];

  useEffect(() => {
    if (!onOrderHistory || urlWallet || !isAiWallet) return;
    const params = new URLSearchParams(location.search);
    params.set("wallet", walletParam);
    history.replace({
      pathname: location.pathname,
      search: params.toString(),
    });
  }, [
    onOrderHistory,
    urlWallet,
    isAiWallet,
    walletParam,
    history,
    location.pathname,
    location.search,
  ]);

  return (
    <div>
      <ListingLayout
        title={`Review Packages`}
        mode={`Update`}
        pageName="Profile"
        parentLink="/"
        childLink="/"
        customTitle={``}
        showLocationToggle={true}
        history={history}
        hidePageHeader={true}
        hideHeader={true}
        hideAdd={true}
        zenBackdrop
        hasLargeContent
        paths={paths}
        showProfileTabs={true}
        profileLocation={location}
      >
        <Box mb="1rem">
          <Suspense fallback={<></>}>
            <Switch>
              <Route
                exact
                path={`/d/review/packages`}
                render={() => <ReviewPackages />}
              />
              <Route
                exact
                path={`/d/review/packages/order-history`}
                render={() => <History />}
              />
            </Switch>
          </Suspense>
        </Box>
      </ListingLayout>
    </div>
  );
};

export default PackageTabs;
